<template>
  <div class="app sidebar-fixed aside-menu-fixed sidebar-sm-show">
    <!-- <div class="app"> -->
    <b-navbar
      toggleable="md"
      variant="info"
      style="background-color: #fff !important;height: 50px; padding-left: 0px;padding-top: 0px; padding-bottom: 0px;position: fixed !important; z-index: 1020;width: 100%; "
    >
      <div>
        <a href="/">
          <img class="navbar-brand-full" src="/static/img/haus_logo.jpg" style="height:40px;" />
        </a>
        <!--
      activate code below to activate menu toggling (only for mobile version available). Also line #2 update the class to "app" only
        <SidebarToggler display="sm" class="sidebar-show"><i class="nav-icon icon-menu"></i></SidebarToggler>-->
      </div>
      <!-- <b-collapse is-nav id="nav_collapse"> -->
      <b-navbar-nav class="ml-auto">
        <nav-header-user :user="this.user"></nav-header-user>
      </b-navbar-nav>
      <!-- </b-collapse> -->
    </b-navbar>
    <div class="app-body" style="padding-top: 50px;" v-if="user.hausType >= 0">
      <AppSidebar fixed>
        <!-- <SidebarNav :navItems="nav"></SidebarNav> -->
        <!-- _nav.js default begin  -->
        <nav data-v-1282947e class="sidebar-nav" v-if="showMenu == 'default'">
          <section
            data-v-1282947e
            class="ps-container scroll-area ps ps--theme_default"
            data-ps-id="1c1d1dd1-a932-58cd-884e-4ccb0173eae8"
          >
            <ul data-v-1282947e class="nav">
              <li data-v-1282947e class="nav-item" v-if="user.hausType > 0">
                <div data-v-1282947e>
                  <a href="/" class="nav-link">
                    <i class="nav-icon icon-speedometer"></i> Dashboard
                  </a>
                </div>
              </li>

              <li data-v-1282947e class="nav-item" v-if="user.hausType > 0">
                <div data-v-1282947e>
                  <a href="/#/base/allLocks" class="nav-link">
                    <i class="nav-icon icon-lock"></i> Lock List
                  </a>
                </div>
              </li>
              <li data-v-1282947e class="nav-item" v-if="user.hausType > 0">
                <div data-v-1282947e>
                  <a href="/#/base/statistics/" class="nav-link">
                    <i class="nav-icon icon-chart"></i> Statistic
                  </a>
                </div>
              </li>
              <li data-v-1282947e class="nav-item" v-if="user.hausType == 1">
                <div data-v-1282947e>
                  <a href="/#/base/managerForLocation" class="nav-link">
                    <i class="nav-icon icon-people"></i> Managers
                  </a>
                </div>
              </li>
              <li
                data-v-1282947e
                class="nav-item"
                v-if="this.signinMethod == 'local' && user.hausType > 0"
              >
                <div data-v-1282947e>
                  <a href="/#/base/userprofile/" class="nav-link">
                    <i class="nav-icon icon-user"></i>My Profile
                  </a>
                </div>
              </li>
              <li data-v-1282947e class="nav-item" v-if="user.hausType == 0">
                <div data-v-1282947e>
                  <a href="#/base/assignHausType/" class="nav-link">
                    <i class="nav-icon icon-people"></i> Assign HAUS type
                  </a>
                </div>
              </li>
              <li data-v-1282947e class="nav-item" v-if="user.hausType == 0">
                <div data-v-1282947e>
                  <a href="#/base/managerStatus/" class="nav-link">
                    <i class="nav-icon icon-people"></i> Manager Status
                  </a>
                </div>
              </li>
            </ul>
            <div class="ps__scrollbar-x-rail" style="left: 0px; bottom: 0px;">
              <div class="ps__scrollbar-x" tabindex="0" style="left: 0px; width: 0px;"></div>
            </div>
            <div class="ps__scrollbar-y-rail" style="top: 0px; right: 0px;">
              <div class="ps__scrollbar-y" tabindex="0" style="top: 0px; height: 0px;"></div>
            </div>
          </section>
        </nav>
        <!-- _nav.js default end -->

        <nav
          data-v-1282947e
          class="sidebar-nav"
          v-if="showMenu == 'settings' && user.hausType == 1 "
        >
          <section
            data-v-1282947e
            class="ps-container scroll-area ps ps--theme_default"
            data-ps-id="1c1d1dd1-a932-58cd-884e-4ccb0173eae8"
          >
            <ul data-v-1282947e class="nav">
              <li data-v-1282947e class="divider"></li>
              <li data-v-1282947e class="nav-item" v-if="user.hausType == 1">
                <div data-v-1282947e>
                  <a href="#/base/locations/" class="nav-link">
                    <i class="nav-icon icon-location-pin"></i> Location
                  </a>
                </div>
              </li>
              <li data-v-1282947e class="divider"></li>
              <li data-v-1282947e class="nav-item" v-if="user.hausType == 1">
                <div data-v-1282947e>
                  <a href="#/base/lockGroupFormAndList/" class="nav-link">
                    <i class="nav-icon icon-layers"></i> Lock Group
                  </a>
                </div>
              </li>
              <li data-v-1282947e class="nav-item" v-if="user.hausType == 1">
                <div data-v-1282947e>
                  <a href="#/base/locks/" class="nav-link">
                    <i class="nav-icon icon-lock"></i> Locks
                  </a>
                </div>
              </li>
              <li data-v-1282947e class="nav-item" v-if="user.hausType == 1">
                <div data-v-1282947e>
                  <a href="#/base/manager/" class="nav-link">
                    <i class="nav-icon icon-people"></i> Manager
                  </a>
                </div>
              </li>
            </ul>
            <div class="ps__scrollbar-x-rail" style="left: 0px; bottom: 0px;">
              <div class="ps__scrollbar-x" tabindex="0" style="left: 0px; width: 0px;"></div>
            </div>
            <div class="ps__scrollbar-y-rail" style="top: 0px; right: 0px;">
              <div class="ps__scrollbar-y" tabindex="0" style="top: 0px; height: 0px;"></div>
            </div>
          </section>
        </nav>

        <div data-v-11282947e v-if="showMenu == 'default' && ouht > 0">
          <ul data-v-11282947e class="nav">
            <li class="nav-divider"></li>
            <li class="nav-title">Locks Utilization</li>
            <li class="nav-item px-3 d-compact-none d-minimized-none">
              <div class="text-uppercase mb-1">
                <small>
                  <div style="position:absolute;">
                    <b>Total Locks</b>
                  </div>
                  <div style="float:right; position:relative;">{{utilization.totalLocks}}</div>
                </small>
              </div>
              <div
                class="progress progress-xs"
                style="position:relative;margin-top:15px;width:100%;margin-bottom:5px;"
              >
                <div
                  class="progress-bar bg-info"
                  role="progressbar"
                  :style="utilization.bookedStyle"
                  :aria-valuenow="utilization.bookedPercentage"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </li>
            <li class="nav-item px-3 d-compact-none d-minimized-none">
              <div class="text-uppercase mb-1">
                <small>
                  <div style="position:absolute;">
                    <b>Total eKeys</b>
                  </div>
                  <div style="float:right">{{utilization.ekeys}}</div>
                </small>
              </div>
              <div
                class="progress progress-xs"
                style="position:relative;margin-top:15px;width:100%;margin-bottom:5px;"
              >
                <div
                  class="progress-bar bg-primary"
                  role="progressbar"
                  style="width: 100%"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </li>
            <li class="nav-item px-3 d-compact-none d-minimized-none">
              <div class="text-uppercase mb-1">
                <small>
                  <div style="position:absolute;">
                    <b>Total passcodes</b>
                  </div>
                  <div style="float:right">{{utilization.passcodes}}</div>
                </small>
              </div>
              <div
                class="progress progress-xs"
                style="position:relative;margin-top:15px;width:100%;margin-bottom:20px;"
              >
                <div
                  class="progress-bar bg-warning"
                  role="progressbar"
                  style="width: 100%"
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </li>
          </ul>
        </div>
        <div data-v-1282947e>
          <a
            href="#/pages/login"
            class="nav-link newport-sidebar"
            @click="logout"
            style="background-color:#336767;padding-bottom: 60px;"
          >
            <i class="nav-icon icon-power"></i> Logout
          </a>
        </div>
      </AppSidebar>
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!-- <DefaultAside/> -->
      </AppAside>
    </div>
    <TheFooter>
      Ver beta 20181107
      <!-- <SidebarToggler class="d-md-down-none" display="sm" ><i class="nav-icon icon-menu"></i></SidebarToggler> -->
    </TheFooter>
  </div>
</template>

<script>
import nav from "../_nav";
import {
  Header as AppHeader,
  HeaderDropdown as AppHeaderDropdown,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
// import { Header as AppHeader, HeaderDropdown as AppHeaderDropdown, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Breadcrumb } from '../components/'
// import { Footer as TheFooter } from '@coreui/vue'
import DafaultAside from "./DafaultAside";
import NavHeaderUser from "@/views/base/haus/NavHeaderUser";

let qs = require("qs");

const constants = require("../views/base/shared/constants");
const BASE = constants.NEWPORT_CONST.API_URL;
const API = BASE + "/api/locks/utilization";
//const API_USER_DETAIL = BASE + "/api/users/detail";

function postdata(url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      "content-type": "application/x-www-form-urlencoded",
      accessToken: localStorage.getItem("token"),
      authorization: localStorage.getItem("token")
    },
    method: "POST"
  }).then(res => res.json());
}

async function getData() {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem("token"),
    locationId: localStorage.getItem("locationId"),
    fromHaus: 1
  };
  let res = await postdata(API, parameters);
  return res.result;
}

// async function userDetail() {
//   let parameters = {
//     client_id: constants.NEWPORT_CONST.CLIENT_ID,
//     client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
//     access_token: localStorage.getItem("token")
//   };
//
//   let res = await postdata(API_USER_DETAIL, parameters);
//
//   return res.user;
// }

export default {
  name: "full",
  components: {
    AsideToggler,
    AppHeader,
    AppHeaderDropdown,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DafaultAside,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    NavHeaderUser
  },
  data() {
    return {
      nav: nav.items,
      utilization: {},
      itemsCount: 42,
      showMenu: null,
      ouht: null,
      user: {},
      signinMethod: ""
    };
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched;
    }
  },
  mounted() {
    let google_token = localStorage.getItem("google_token");
    let local_token = localStorage.getItem("token");
    let facebook_id = localStorage.getItem("fb_id");
    this.$data.signinMethod = localStorage.getItem("signinMethod");
    if (local_token) {
      let localUserDetail = localStorage.getItem("localUserDetail");

      if(localUserDetail == null || localUserDetail == "undefined") {
        constants.gotoLogin()
      } else {
        localUserDetail = JSON.parse(localUserDetail)
        this.$data.user = localUserDetail
      }

      // if (userDetailLocal === null) {
      //   userDetail().then(response => {
      //     localStorage.setItem("userDetailLocal", JSON.stringify(response));
      //     if (response == undefined) {
      //       this.$router.push("/pages/login");
      //     } else {
      //       this.$data.user = response;
      //     }
      //   });
      // } else {
      //   userDetailLocal = JSON.parse(localStorage.getItem("userDetailLocal"));
      //   this.$data.user = userDetailLocal;
      // }

      let ouht = localStorage.getItem("ouht");
      if (ouht) {
        let localLocksUtil = localStorage.getItem("localLocksUtil");

        if (localLocksUtil === null || localLocksUtil === 'undefined') {
          getData().then(response => {
            localStorage.setItem("localLocksUtil", JSON.stringify(response));
            this.$data.utilization = response;
          });
        } else {
          this.$data.utilization = JSON.parse(localLocksUtil);
        }
      }
      let localShowmenu = localStorage.getItem("showmenu");

      if (localShowmenu === "settings") {
        this.showMenu = "settings";
      } else {
        this.showMenu = "default";
      }
    } else {
      this.$router.push("/pages/login");
    }
  },
  methods: {
    getAvatar() {
      return localStorage.getItem("avatar");
    },
    isLoggedIn() {
      return localStorage.getItem("token");
    },
    loginPage(event) {
      event.preventDefault();
      this.$router.push("/pages/login");
    },
    logout(event) {
      let usingFacebook = localStorage.getItem("signinMethod");
      if (usingFacebook == "facebook") {
        this.fbLogoutUser();
      }
      localStorage.clear();

      this.$router.push({
        name: "Login",
        query: {
          t: +new Date()
        }
      });
    },
    fbLogoutUser() {
      FB.getLoginStatus(function(response) {
        if (response && response.status === "connected") {
          FB.logout(function(responseLogout) {
            document.location.reload();
          });
        }
      });
    },
    openSettings() {
      localStorage.setItem("showmenu", "settings");
      this.$data.showMenu = "settings";
      location.href = "/#/base/locations/";
    },
    closeSettings() {
      localStorage.setItem("showmenu", "default");
      this.$data.showMenu = "default";
      location.href = "/";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/containers/DefaultContainer.vue